import styled from 'styled-components';

const MapContainer = styled.div`
  position: relative;

  svg {
    position: absolute;
  }
`;

export default MapContainer;
